import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function createUserPassword(client_id: any, email: any, language: any, password: string) {
    try {
        const response = await axios.post(
            API_URL + '/create_online_password',
            {
                client_id: client_id,
                email: email,
                language: language,
                password: password
            }
        )
        // console.log(response);

        if ("error" in response.data) {
            return response.data.error
        }

        if ("user" in response.data) {
            return "password_set"
        }

    } catch (error) {
        return "create_user_password_error"

    }
}